import apiService from "./ApiService";
import { ApiEndpoints } from "./ApiConstants";

export const getUpcomingMatches = () => {
    return apiService
        .get(ApiEndpoints.GET_SCHEDULED_MATCHES)
        .then((response) => response.data)
        .catch((error) => error.response);
};

export const getLiveMatches = () => {
    return apiService
        .get(ApiEndpoints.LIVE_MATCHES)
        .then((response) => response.data)
        .catch((error) => error.response);
};

export const getSchedulerLiveMatches = () => {
    return apiService
        .get("/scheduler/matches/live")
        .then((response) => response.data)
        .catch((error) => error.response);
};

export const getMatchesCard = (type, page = 0, size = 10, range = null, serverIds = null) => {
    return apiService
        .get(ApiEndpoints.GET_MATCHES_CARD, {
            params: { type, page, size, ...(range ? { range } : {}), ...(serverIds && serverIds.length > 0 ? { serverId: serverIds } : {}) }
        })
        .then((response) => response.data)
        .catch((error) => error.response);
};

export const getMatchDetails = (matchId) => {
    return apiService
        .get(`/matches/${matchId}/details`)
        .then((response) => response.data)
        .catch((error) => error.response);
};

export const getLiveScore = (matchId) => {
    return apiService
        .get(`/matches/${matchId}/live-score`)
        .then((response) => response.data)
        .catch((error) => error.response);
};

export const getServers = () => {
    return apiService
        .get(ApiEndpoints.GET_SERVERS)
        .then((response) => response.data)
        .catch((error) => error.response);
};